

import {shrink} from "./methods/shrink.js";
import {expand} from "./methods/expand.js";
import {hideExpandableMenu} from "./methods/hideExpandableMenu.js";
import {showExpandableMenu} from "./methods/showExpandableMenu.js";

import {getExpandableSideMenu} from "./methods/getExpandableSideMenu.js";
import {getDefaultSideMenu} from "./methods/getDefaultSideMenu.js";
import {render} from "./methods/render.js";

import {getId} from "./../universal_methods/getId.js";  
import {setId} from "./../universal_methods/setId.js";





export class SmetioSideMenu{
    
    constructor(){
        
        this.id = "";
        
        this.extraClass = "";
        
        this.side = "";
        
        this.position = "";
        
        this.closeStatus = "";
        
        this.extra_attributes = "";
        
        this.content = "";

        this.menuType = "default";
        this.widthMovement = 5;
        this.currentWidth = 15;
        this.minWidth = 15;
        this.maxWidth = 80;
        this.arrowHolderWidth = "20px";

        this.getId = getId;
        this.setId = setId;

        this.hideExpandableMenu = hideExpandableMenu;
        this.showExpandableMenu = showExpandableMenu;
        this.shrink = shrink;
        this.expand = expand;
        this.getExpandableSideMenu = getExpandableSideMenu;
        this.getDefaultSideMenu = getDefaultSideMenu;

        this.render = render;
            
    };

}
